import { Box, Stack, SxProps, Theme, Typography } from '@mui/material';
import React from 'react';
import { formatMetricValue } from '../../../helpers';
import { MetricChartLine } from '../../../types';

// Shared chart key: a colored dot, the metric name and its period total.
// Used by every analytics chart so the legend stays consistent.
export default function ChartLegend({
  lines,
  totals,
  sx,
}: {
  lines: MetricChartLine[];
  totals: Record<string, number>;
  sx?: SxProps<Theme>;
}) {
  return (
    <Stack
      direction="row"
      flexWrap="wrap"
      gap={2}
      justifyContent="center"
      sx={{ height: 22, flexShrink: 0, ...sx }}
    >
      {lines.map(line => (
        <Box key={line.dataKey} display="inline-flex" alignItems="center" gap={0.75}>
          <Box width={8} height={8} borderRadius="50%" bgcolor={line.color} />
          <Typography fontSize="0.9rem" color="text.secondary">
            {line.name}
          </Typography>
          <Typography fontSize="0.9rem" fontWeight="fontWeightBold">
            {formatMetricValue(totals[line.dataKey] ?? 0)}
          </Typography>
        </Box>
      ))}
    </Stack>
  );
}
